module.exports = __webpack_public_path__ + "static/fonts/TitilliumWeb-Regular.4f5848e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TitilliumWeb/TitilliumWeb-Regular.ttf
// module id = FQll
// module chunks = 0